





























































import Base from '@/views/Base';
import { Component, Prop, Watch } from 'vue-property-decorator';
import ElementCard from '@/views/presentation/components/ElementCard.vue';
import { ElementListItem } from '@/models/Presentation';
import draggable from 'vuedraggable';
import ElementRow from '@/views/presentation/components/ElementRow.vue';

@Component({
  components: { ElementRow, ElementCard, draggable }
})
export default class PresentationElementTable extends Base {
  @Prop({ required: true }) value!: ElementListItem[];
  @Prop({ type: Boolean, default: false }) showNotes!: boolean;
  @Prop() selectedElement!: ElementListItem | null;
  @Prop({ type: Boolean }) allSelected!: boolean;

  items: ElementListItem[] = [];

  created(): void {
    this.items = this.value;
  }

  @Watch('value', { immediate: true, deep: true })
  onItemsChanged(newItems: ElementListItem[]) {
    this.items = [...newItems];
  }

  updateItems() {
    this.$emit('input', this.items);
  }
}
